import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'nec-search-box-manual',
  templateUrl: './search-box-manual.component.html',
  styleUrls: ['./search-box-manual.component.scss']
})

export class NecSearchBoxManualComponent {
  // placeholder å­ç¬¦ä¸²
  @Input() holderStr: string;
  // æ¥è¯¢äºä»¶
  @Output() search = new EventEmitter<string>();
  // æ¥è¯¢å­ç¬¦ä¸²
  searchStr: string = null;

  onSearch() {
    this.search.emit(this.searchStr ? this.searchStr.trim() : null);
  }

  clear() {
    this.searchStr = null;
    this.search.emit(null);
  }
}

